import { useState } from 'react'
import swal from 'sweetalert'
import { Usuario } from '../../model/Usuario'
import { setUsuario } from '../../provider/actions'
import { useProvider } from '../../provider/Provider'
import UsuarioService from '../../services/UsuarioService'
import EditUser from './EditUser'
import { Container } from './style'

const MeuPerfil = () => {
    const { usuario, dispatch } = useProvider()
    const [editing, setEditing] = useState(false)

    const goToEditarPerfil = () => {
        if (usuario) {
            setEditing(true)
        }
    }

    const salvar = (user: Usuario) => {
        const newUser = user
        if (user.password) newUser.password = user.password
        UsuarioService.update(newUser)
            .then((data) => {
                setUsuario(dispatch, data)
                setEditing(false)
                swal({
                    title: 'Perfil editado com sucesso!',
                    icon: 'success',
                    buttons: [false],
                    timer: 2000
                })
            })
            .catch(() => {
                swal({
                    title: 'Falha ao editar perfil!',
                    icon: 'error',
                    buttons: [false],
                    timer: 2000
                })
            })
    }

    const cancelar = () => {
        setEditing(false)
    }

    return (
        <Container>
            <div>
                <h3 className="center">Meu Perfil</h3>
                <div className="content">
                    <div className="avatar center">
                        <i className="fas fa-user-circle fa-4x" />
                    </div>
                    <div className={`${editing ? 'info hidden' : 'info'}`}>
                        <label>Nome</label>
                        <p>
                            {usuario?.firstName}
                            <span> </span>
                            {usuario?.lastName}
                        </p>
                        <label>Email</label>
                        <p>{usuario?.email}</p>
                        <button onClick={goToEditarPerfil}>
                            Editar perfil
                        </button>
                    </div>
                    <div className={`${editing ? 'form-box' : 'hidden'}`}>
                        {
                            usuario
                                ? (
                                    <EditUser
                                        salvar={salvar}
                                        cancelar={cancelar}
                                        usuario={usuario}
                                    />
                                ) : false
                        }
                    </div>
                </div>
            </div>
        </Container>
    )
}

export default MeuPerfil
